
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    ElButton: () => import('@/components/forms/ElButton.vue'),
    Dots: () => import('@/assets/svg/dots.svg'),
  },
})
export default class PageAuth extends Vue {
  @Prop({ default: false }) readonly hasHeader!: boolean;

  @Prop({ default: false }) readonly open!: boolean;

  @Prop({ default: '/img/assets/dampshop-banner-image.jpg' }) readonly backgroundImage!: string;
}
